/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-26 11:34:56
 * @LastEditors: 诺
 * @LastEditTime: 2022-06-28 15:36:19
 * @Description: file content
 * requiresAuth 1静默授权 2用户授权  0无需授权
 */
import MyRouter from "@/routers/index";
import config from "./config";
let myRouter = new MyRouter({
  fake: config.env[process.env.VUE_APP_SERVE_ENV].routersActWxauth.fake,
  servicesActWxjssdk: config.env[process.env.VUE_APP_SERVE_ENV].servicesActWxjssdk,
});

myRouter.router.addRoutes([
  {
    path: "/test",
    name: "test",
    meta: {
      title: "测试朋友圈分享",
      requiresAuth: 0,
    },
    component: () => import("./testShareAppId.vue"),
  },
  {
    path: "/layout",
    name: "layout",
    meta: {
      title: "",
      requiresAuth: 0,
    },
    component: () => import("./layout.vue"),
    children: [
      {
        path: "/index",
        name: "index",
        meta: {
          title: "幸运大转盘",
          requiresAuth: 1,
        },
        component: () => import("./index.vue"),
      },
      {
        path: "/rule",
        name: "rule",
        meta: {
          title: "活动规则",
          requiresAuth: 1,
        },
        component: () => import("./rule.vue"),
      },
      {
        path: "/ranking",
        name: "ranking",
        meta: {
          title: "排行榜",
          requiresAuth: 1,
        },
        component: () => import("./ranking.vue"),
      },
      {
        path: "/prize",
        name: "prize",
        meta: {
          title: "我的奖品",
          requiresAuth: 1,
        },
        component: () => import("./prize.vue"),
      },
      {
        path: "/writeoff",
        name: "writeoff",
        meta: {
          title: "核销",
          requiresAuth: 1,
        },
        component: () => import("./writeoff.vue"),
      },
      {
        path: "/testShareAppId",
        name: "testShareAppId",
        meta: {
          title: "测试朋友圈分享",
          requiresAuth: 0,
        },
        component: () => import("./testShareAppId.vue"),
      },
    ],
  },
]);
export default myRouter.router;
